/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MetricsInputs */



/**
* | output |
* | --- |
* | "Metrics" |
*
* @param {MetricsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metrics = /** @type {((inputs?: MetricsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MetricsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Métriques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metriken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metriche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метрики")
	if (locale === "es") return /** @type {LocalizedString} */ ("Métricas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("指标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メトリクス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेट्रिक्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Métricas")
	return /** @type {LocalizedString} */ ("Metrics")
});